var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',_vm._b({on:{"before-enter":_vm.setup,"leave":_vm.hideItems}},'transition-group',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }